import React, { useEffect, useState, useRef } from 'react'
import Topbar from '../../Components/Topbar'
import LeftbarUser from '../../Components/LeftbarUser'
import BottomNavUser from '../../Components/BottomNavUser'
import profDefault from '../../Images/def.png'
import { useNavigate, useLocation } from 'react-router-dom'
import defMess from '../../Images/mwanadamu.png'
import defMess2 from '../../Images/allura.png'
import { getFirestore, doc, getDoc } from 'firebase/firestore'
import { getDatabase, ref, onValue, push, onDisconnect, set } from 'firebase/database'
import { getAuth } from 'firebase/auth'
import { getStorage, ref as storageRef, uploadBytesResumable, getDownloadURL } from 'firebase/storage'
import AttachmentViewer from '../AttachmentViewer'
import '../../Messages.css'

function timeAgo(timestamp) {
    const now = Date.now()
    const diff = now - timestamp
    const seconds = Math.floor(diff / 1000)
    if (seconds < 60) return `${seconds}s ago`
    const minutes = Math.floor(seconds / 60)
    if (minutes < 60) return `${minutes}m ago`
    const hours = Math.floor(minutes / 60)
    if (hours < 24) return `${hours}h ago`
    const days = Math.floor(hours / 24)
    if (days < 7) return `${days}d ago`
    const weeks = Math.floor(days / 7)
    if (weeks < 4) return `${weeks}w ago`
    const months = Math.floor(days / 30)
    if (months < 12) return `${months}mo ago`
    const years = Math.floor(days / 365)
    return `${years}y ago`
}

function UserMessages() {
    const navigate = useNavigate()
    const location = useLocation()
    const { receiverId: initialReceiverId } = location.state || {}
    const [currentUserId, setCurrentUserId] = useState('')
    const [conversations, setConversations] = useState([])
    const [receiver, setReceiver] = useState(null)
    const [messages, setMessages] = useState([])
    const [newMessage, setNewMessage] = useState('')
    const [searchTerm, setSearchTerm] = useState('')
    const [onlineUsers, setOnlineUsers] = useState({})
    const [attachmentFile, setAttachmentFile] = useState(null)
    const [uploadProgress, setUploadProgress] = useState(0)
    const [viewAttachment, setViewAttachment] = useState(null)
    const chatEndRef = useRef(null)
    const fileInputRef = useRef(null)

    const auth = getAuth()
    const db = getFirestore()
    const rtdb = getDatabase()
    const storage = getStorage()

      useEffect(() => {
        document.title = "Zindua App | Dashboard";
    
        // Meta description
        let desc = document.querySelector("meta[name='description']");
        if (!desc) {
          desc = document.createElement("meta");
          desc.setAttribute("name", "description");
          document.head.appendChild(desc);
        }
        desc.setAttribute("content", "Zindua App dashboard");
    
        // Open Graph tags
        const ogTags = [
          { property: "og:title", content: "Zindua App | Dashboard" },
          { property: "og:description", content: "Zindua App Dashboard" },
          { property: "og:type", content: "website" },
          { property: "og:url", content: "https://zindua.app/dashboard" },
          { property: "og:image", content: "https://zindua.app/logo192.png" },
        ];
    
        ogTags.forEach(({ property, content }) => {
          let tag = document.querySelector(`meta[property='${property}']`);
          if (!tag) {
            tag = document.createElement("meta");
            tag.setAttribute("property", property);
            document.head.appendChild(tag);
          }
          tag.setAttribute("content", content);
        });
    
        // JSON-LD structured data
        const script = document.createElement("script");
        script.type = "application/ld+json";
        script.text = JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "Zindua App Influencer Dashboard",
          "url": "https://zindua.app/dashboard",
          "description": "Zindua App influencer dashboard where you can manage your earnings, running ads, subscriptions, and withdraw funds to M-Pesa.",
          "inLanguage": "en",
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://zindua.app/"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Dashboard",
                "item": "https://zindua.app/dashboard"
              }
            ]
          }
        });
        document.head.appendChild(script);
    
        return () => {
          document.head.removeChild(script);
        };
      }, []);

    // Set presence
    useEffect(() => {
        const user = auth.currentUser
        if (user) {
            setCurrentUserId(user.uid)
            const statusRef = ref(rtdb, `presence/${user.uid}`)
            set(statusRef, true)
            onDisconnect(statusRef).set(false)
        }
    }, [auth, rtdb])

    // Track online users
    useEffect(() => {
        const presenceRef = ref(rtdb, 'presence')
        return onValue(presenceRef, snapshot => {
            setOnlineUsers(snapshot.val() || {})
        })
    }, [rtdb])

    const [showChatWindow, setShowChatWindow] = useState(false)
    const isMobile = window.innerWidth <= 768

    // Fetch conversations
    useEffect(() => {
        if (!currentUserId) return

        const fetchConversations = async () => {
            const chatsRef = ref(rtdb, 'chats')
            onValue(chatsRef, async snapshot => {
                const data = snapshot.val() || {}
                const convs = []

                for (const chatId of Object.keys(data)) {
                    if (!chatId.includes(currentUserId)) continue
                    const chatData = data[chatId]
                    const messagesArray = Object.values(chatData)
                    messagesArray.sort((a, b) => a.timestamp - b.timestamp)
                    const lastMessage = messagesArray[messagesArray.length - 1]

                    const otherUserId = chatId.split('_').find(id => id !== currentUserId)
                    const userRef = doc(db, 'users', otherUserId)
                    const docSnap = await getDoc(userRef)
                    const userName = docSnap.exists() ? docSnap.data().userName : 'Unknown'

                    let preview = lastMessage.message
                    if (!preview && lastMessage.attachmentName) preview = 'Attachment'

                    convs.push({
                        chatId,
                        lastMessage: preview,
                        lastMessageTime: lastMessage.timestamp,
                        otherUserId,
                        userName
                    })
                }

                convs.sort((a, b) => b.lastMessageTime - a.lastMessageTime)
                setConversations(convs)
            })
        }

        fetchConversations()
    }, [currentUserId, db, rtdb])

    // Open chat if passed from location
    useEffect(() => {
        if (!currentUserId) return
        if (initialReceiverId) openChat(initialReceiverId)
    }, [currentUserId, initialReceiverId])

    // Scroll to bottom
    useEffect(() => {
        if (chatEndRef.current) chatEndRef.current.scrollIntoView({ behavior: 'smooth' })
    }, [messages])

    const openChat = async userId => {
        if (isMobile) setShowChatWindow(true)

        const chatId = [currentUserId, userId].sort().join('_')

        const userRef = doc(db, 'users', userId)
        const docSnap = await getDoc(userRef)
        if (docSnap.exists()) {
            const data = docSnap.data()
            setReceiver({
                userId,
                userName: data.userName || 'Unknown',
                profileImage: data.profileImage || profDefault
            })
        }

        const messagesRef = ref(rtdb, `chats/${chatId}`)

        onValue(messagesRef, snapshot => {
            const data = snapshot.val() || {}
            const formatted = Object.keys(data).map(key => ({
                id: key,
                ...data[key]
            }))
            formatted.sort((a, b) => a.timestamp - b.timestamp)
            setMessages(formatted)

            // MARK AS READ
            const lastReadRef = ref(rtdb, `lastRead/${chatId}/${currentUserId}`)
            set(lastReadRef, Date.now())
        })


    }

    const handleSendMessage = async () => {
        if ((!newMessage.trim() && !attachmentFile) || !receiver?.userId) return
        const chatId = [currentUserId, receiver.userId].sort().join('_')
        const messagesRef = ref(rtdb, `chats/${chatId}`)

        let attachmentData = null
        if (attachmentFile) {
            const fileRef = storageRef(storage, `chatAttachments/${chatId}/${Date.now()}_${attachmentFile.name}`)
            const uploadTask = uploadBytesResumable(fileRef, attachmentFile)

            uploadTask.on('state_changed', snapshot => {
                setUploadProgress(Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100))
            })

            await new Promise((resolve, reject) => {
                uploadTask.on(
                    'state_changed',
                    null,
                    err => reject(err),
                    async () => {
                        const url = await getDownloadURL(uploadTask.snapshot.ref)
                        attachmentData = {
                            attachmentUrl: url,
                            attachmentType: attachmentFile.type.startsWith('video') ? 'video' : 'image',
                            attachmentName: attachmentFile.name
                        }
                        setAttachmentFile(null)
                        setUploadProgress(0)
                        resolve()
                    }
                )
            })
        }

        push(messagesRef, {
            senderId: currentUserId,
            receiverId: receiver.userId,
            message: newMessage,
            timestamp: Date.now(),
            ...attachmentData
        })
        setNewMessage('')
    }

    const filteredConversations = conversations.filter(conv =>
        conv.userName.toLowerCase().includes(searchTerm.toLowerCase())
    )

    const [isAtBottom, setIsAtBottom] = useState(true)
    const chatMessagesRef = useRef(null)

    useEffect(() => {
        if (!isAtBottom) return
        const el = chatMessagesRef.current
        if (!el) return
        el.scrollTop = el.scrollHeight
    }, [messages, isAtBottom])

    return (
        <div className="mainDashboard">
            {viewAttachment &&
                <AttachmentViewer
                    url={viewAttachment.url}
                    type={viewAttachment.type}
                    onClose={() => setViewAttachment(null)}
                />
            }
            <div className="desktopOnly"><LeftbarUser /></div>
            <div className="mainContent2">
                {/* <Topbar /> */}
                <section className="messagingContainer">
                    {(!isMobile || !showChatWindow) && (
                        <div className="chatSidebar">
                            <div className="">
                                <div className="chatSidebarHeader">
                                    <input
                                        type="text"
                                        placeholder="Search"
                                        className="searchInput"
                                        value={searchTerm}
                                        onChange={e => setSearchTerm(e.target.value)}
                                    />
                                </div>
                                <div className="chatList">
                                    {filteredConversations.length === 0 ?
                                        (<div className="noChats">
                                            <img src={defMess2} alt="" />
                                            <p>No conversations yet</p>
                                        </div>) :
                                        (filteredConversations.map(conv => (
                                            <div key={conv.chatId}
                                                className={`chatItem ${receiver?.userId === conv.otherUserId ? 'selected' : ''}`}
                                                onClick={() => openChat(conv.otherUserId)} >
                                                <UserPreview
                                                    userId={conv.otherUserId}
                                                    lastMessage={conv.lastMessage}
                                                    lastMessageTime={conv.lastMessageTime}
                                                    online={!!onlineUsers[conv.otherUserId]} />
                                            </div>)))}
                                </div>
                            </div>
                        </div>
                    )}

                    {(!isMobile || showChatWindow) && (

                        <div className="chatWindow">
                            {!receiver ? (
                                <div className="noChatSelected">
                                    <img src={defMess} alt="" />
                                    <p>Select a user to start chatting</p>
                                </div>
                            ) : (
                                <>
                                    <div className="chatWindowHeader">

                                        <div className="chatUserInfo">
                                            <img src={receiver.profileImage} className="avatar" />
                                            <div>
                                                <p className="userName">
                                                    {receiver.userName} {onlineUsers[receiver.userId] && <span className="onlineDot">●</span>}
                                                </p>
                                                <p className="userStatus">{onlineUsers[receiver.userId] ? 'Online' : 'Offline'}</p>
                                            </div>
                                        </div>

                                        {isMobile && (
                                            <button
                                                className="backButton"
                                                onClick={() => setShowChatWindow(false)}
                                            >
                                                Back
                                            </button>
                                        )}
                                    </div>

                                    <div ref={chatMessagesRef} className="chatMessages" onScroll={e => {
                                        const el = e.target
                                        const threshold = 40
                                        const atBottom =
                                            el.scrollHeight - el.scrollTop - el.clientHeight < threshold

                                        setIsAtBottom(atBottom)

                                        if (atBottom && receiver) {
                                            const chatId = [currentUserId, receiver.userId].sort().join('_')
                                            const lastReadRef = ref(rtdb, `lastRead/${chatId}/${currentUserId}`)
                                            set(lastReadRef, Date.now())
                                        }
                                    }}>
                                        {messages.map(msg => (
                                            <div key={msg.id} className={`messageBubble ${msg.senderId === currentUserId ? 'sent' : 'received'}`}>
                                                {msg.attachmentUrl ? (
                                                    <div className="attachment" onClick={() => setViewAttachment({ url: msg.attachmentUrl, type: msg.attachmentType })}>
                                                        {msg.attachmentType === 'image' ? (
                                                            <img src={msg.attachmentUrl} alt={msg.attachmentName} className="attachmentLarge" />
                                                        ) : (
                                                            <video src={msg.attachmentUrl} className="attachmentLarge" controls />
                                                        )}
                                                        <p>{msg.attachmentName}</p>
                                                    </div>
                                                ) : (
                                                    <p>{msg.message}</p>
                                                )}
                                                <span className="messageTime">{timeAgo(msg.timestamp)}</span>
                                            </div>
                                        ))}
                                        <div ref={chatEndRef}></div>
                                    </div>

                                    <div className="chatInputBar">
                                        {attachmentFile && (
                                            <div className="attachmentPreviewItem">
                                                {attachmentFile.type.startsWith('image') ? (
                                                    <img src={URL.createObjectURL(attachmentFile)} alt="preview" className="attachmentPreviewSmall" />
                                                ) : (
                                                    <video src={URL.createObjectURL(attachmentFile)} className="attachmentPreviewSmall" controls />
                                                )}
                                                {uploadProgress > 0 && <div className="uploadProgress">{uploadProgress}%</div>}
                                                <button className="removeAttachmentBtn" onClick={() => setAttachmentFile(null)}>×</button>
                                            </div>
                                        )}
                                        <div className="attachmentContainer">
                                            <button className="attachButton" onClick={() => fileInputRef.current.click()}>+</button>
                                            <input
                                                type="file"
                                                ref={fileInputRef}
                                                style={{ display: 'none' }}
                                                accept="image/*,video/*"
                                                onChange={e => setAttachmentFile(e.target.files[0])}
                                            />
                                            <input
                                                type="text"
                                                placeholder="Type a message, press enter to submit"
                                                className="chatInput"
                                                value={newMessage}
                                                onChange={e => setNewMessage(e.target.value)}
                                                onKeyDown={e => e.key === 'Enter' && handleSendMessage()}
                                            />
                                        </div>

                                    </div>

                                </>
                            )}
                        </div>

                    )}
                </section>
            </div>
            <div className="mobileOnly"><BottomNavUser /></div>
        </div>
    )
}

// Sidebar user
function UserPreview({ userId, lastMessage, lastMessageTime, online }) {
    const [user, setUser] = useState({ userName: 'Loading...', profileImage: profDefault })
    const db = getFirestore()

    useEffect(() => {
        const fetchUser = async () => {
            const userRef = doc(db, 'users', userId)
            const docSnap = await getDoc(userRef)
            if (docSnap.exists()) {
                const data = docSnap.data()
                setUser({
                    userName: data.userName || 'Unknown',
                    profileImage: data.profileImage || profDefault
                })
            }
        }
        fetchUser()
    }, [userId, db])

    const preview = lastMessage
        ? lastMessage.length > 25
            ? lastMessage.substring(0, 25) + '...'
            : lastMessage
        : ''

    return (
        <div className="chatItemContent">
            <img src={user.profileImage} className="avatar" />
            <div className="chatInfo">
                <p className="chatName">
                    {user.userName} {online && <span className="onlineDot">●</span>}
                </p>
                <p className="chatPreview">{preview}</p>
            </div>
            <div className="chatTime">
                {lastMessageTime && <span>{timeAgo(lastMessageTime)}</span>}
            </div>
        </div>
    )
}

export default UserMessages